import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing4, Spacing6, Spacing16 } from 'autogen/design-tokens/tokens';
import type { ProductRegimeAdvisorModel } from 'autogen/swagger/all';
import { ReadProfile } from 'autogen/translation-keys/trans-website-advisor';
import { Button } from 'components/Button';
import InlineButton from 'components/generic/InlineButton';
import InlineLinkActionButton from 'components/generic/InlineButton/InlineLinkActionButton';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';
import { Body, Title } from 'components/generic/typography';
import { verticalEllipsis } from 'modules/helpers/mixins';
import { breakpoint, sizes } from 'variables';
import AdvisorAvatar from './AdvisorAvatar';

/* #region  styles */
const Container = styled.div`
    display: flex;
    align-items: center;
`;

const HeadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: ${Spacing16};
`;

const StyledPictureSignature = styled(PictureDeprecated)`
    img {
        height: 34px;

        ${breakpoint.up(sizes.md)} {
            height: 40px;
        }
    }
`;

const StyledBody = styled(Body)`
    margin: 0 0 ${Spacing6};
    ${verticalEllipsis(1)};
`;

const StyledButton = styled(Button)`
    padding: 0;
    height: auto;

    &:focus {
        outline: none;
    }
`;

/* #endregion */

export default function AdvisorHeader({ advisor, ...restProps }: { advisor: ProductRegimeAdvisorModel }) {
    const { mainProfileImage, expertiseFields, profileLinkAction, signatureImage, firstName } = advisor;

    const { t } = useTranslation();

    return (
        <Container {...restProps}>
            <AdvisorAvatar image={mainProfileImage} />
            <HeadingContainer>
                {signatureImage ? <StyledPictureSignature {...signatureImage} /> : <Title size="S">{firstName}</Title>}
                <StyledBody size="M">{expertiseFields}</StyledBody>
                <InlineLinkActionButton action={profileLinkAction} variant="dark" fontWeight="semibold">
                    {t(ReadProfile)}
                </InlineLinkActionButton>
            </HeadingContainer>
        </Container>
    );
}
